import { useRouter } from 'next/router'
import NextLink from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'
import { Link } from '@wartek-id/link'
import { Spinner } from '@wartek-id/spinner'
import { Shimmer } from '@wartek-id/shimmer'

import { Header } from 'app/KinerjaShared/components/Header'
import { usePelaksanaanPerilakuKerjaPS } from 'app/KinerjaPSPegawaiPage/hooks/usePelaksanaanPerilakuKerjaPS'
import useToggleSdkContext from 'utils/useToogleSdk'

import type { PSPerilakuKerjaAspek } from 'types/kinerja-ps-pegawai'

const MapRatingPerilakuKerja = {
  DI_BAWAH_EKSPEKTASI: 'Di bawah ekspektasi',
  SESUAI_EKSPEKTASI: 'Sesuai ekspektasi',
  DI_ATAS_EKSPEKTASI: 'Di atas ekspektasi',
}

const PSPelaksanaanPerilakuKerjaPage = () => {
  const router = useRouter()
  const toggle = useToggleSdkContext()
  const ratingEnabled = toggle?.['kinerja-ps-pegawai-rating-enabled'] || false

  const { pelaksanaan, apiStatus } = usePelaksanaanPerilakuKerjaPS()

  const perilakuKerja: PSPerilakuKerjaAspek[] = !!pelaksanaan
    ? JSON.parse(pelaksanaan.perilakuKerjaValues)
    : []

  return (
    <div className="pt-10 pb-32 mx-auto max-w-7xl">
      <Header
        title="Perilaku Kerja"
        className="mb-9 print:hidden"
        onBack={router.back}
      />

      <div className="flex mt-10 gap-7">
        <div className="flex-1 p-6 bg-white border rounded border-subdued">
          <Text variant="heading-lg">Daftar Perilaku Kerja pilihan Anda</Text>
          <Text className="mt-1">
            <div>
              Anda tidak perlu kumpulkan Bukti Dukung. Cukup laksanakan dalam
              keseharian Anda di luar sistem.
            </div>
            <NextLink
              href="/pengelolaan-kinerja/pengawas-sekolah/pegawai/pelaksanaan/perilaku-kerja/panduan"
              passHref
            >
              <Link className="font-bold">Cek Daftar Perilaku Kerja.</Link>
            </NextLink>
          </Text>

          {apiStatus === 'loading' && (
            <div className="flex justify-center mt-6">
              <Spinner />
            </div>
          )}

          {apiStatus === 'success' && (
            <div
              className="flex flex-col gap-6 mt-6"
              data-testid="perilaku-kerja"
            >
              {perilakuKerja.map((pk) => (
                <div
                  key={pk.aspek}
                  className="flex flex-col gap-6 p-6 bg-white border rounded border-subdued"
                >
                  <Text variant="heading-lg">{pk.aspek}</Text>

                  <div className="flex flex-col gap-1">
                    <Text color="subdued">Indikator</Text>
                    <Text variant="action">{pk.indikator}</Text>
                  </div>

                  <div className="flex flex-col gap-1">
                    <Text color="subdued">Perwujudan</Text>
                    <Text variant="action">{pk.ekspektasi}</Text>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {ratingEnabled && (
          <div className="w-[300px] border border-subdued rounded-lg p-6 bg-white h-max">
            <Text variant="heading-sm">Rating Perilaku Kerja</Text>
            {apiStatus === 'loading' && (
              <div className="mt-2">
                <Shimmer />
              </div>
            )}
            {apiStatus === 'success' && !pelaksanaan?.ratingPerilakuKerja && (
              <Badge variant="informational" className="mt-2">
                Menunggu aksi dari Tim Kinerja
              </Badge>
            )}
            {apiStatus === 'success' && !!pelaksanaan?.ratingPerilakuKerja && (
              <Badge variant="success" className="mt-2">
                {MapRatingPerilakuKerja[pelaksanaan.ratingPerilakuKerja]}
              </Badge>
            )}
            {!pelaksanaan?.ratingPerilakuKerja && (
              <Text color="subdued" className="mt-3">
                Mohon ditunggu dan cek lagi halaman ini nanti.
              </Text>
            )}
          </div>
        )}
      </div>

      <div className="fixed bottom-0 left-0 right-0 z-10 flex justify-center w-full p-4 bg-white border-t border-subdued">
        <NextLink href="/pengelolaan-kinerja/pengawas-sekolah/pegawai" passHref>
          <Button as="a">Ke halaman utama Pelaksanaan</Button>
        </NextLink>
      </div>
    </div>
  )
}

export default PSPelaksanaanPerilakuKerjaPage
